const countOptions = [
  {
    name: "None",
    value: "NONE",
  },
  {
    name: "1-3",
    value: "A1_3",
  },
  {
    name: "4-6",
    value: "A4_6",
  },
  {
    name: "More than 6",
    value: "A6_PLUS",
  },
];

export default countOptions;
